/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import isEqual from 'react-fast-compare';
import Immutable from 'immutable';
import { selectedProductSelector } from 'ctm-selectors';

import styles from './reference_number.css';

/**
 * Reference number component
 * @desc renders a defined label with a component number span element
 * variants include
 *  - default (no variant): label and quote number are rendered inline with no spacing
 *  - rightAligned: label and quote number are aligned right and the quote number is underneath the label
 *  - leftAligned: label and quote number are rendered inline, with some space in between the two
 * @returns {ReferenceNumber} A reference number component
 */
class _ReferenceNumber extends Component {

    /**
     * used to stop unnecessary re-renders
     * @param {Object} nextProps - the props to be set after component update
     * @param {Object} nextState - the state to be set after component update
     * @returns {Boolean} if the props and state are the same, don't update the component
     */
    shouldComponentUpdate = (nextProps) => {
        return !isEqual(nextProps, this.props);
    };

    /**
     * Render the reference number component
     * @returns {Node} ReferenceNumber - the reference number component
     */
    render = () => {
        const { contentProps, visualProps, product } = this.props;
        if (!product.get('providerMeta')) {
            return null;
        }
        // product label should be in local component props from mapStateToProps
        const label = contentProps.label;
        const quoteReferenceNumber = product.getIn(['providerMeta', 'quoteNumber']);
        const color = styles[visualProps.color];

        return quoteReferenceNumber ? (
            <div className={styles[visualProps.textAlign]}>
                <label
                    className={classNames(color, styles[visualProps.labelVariant])}>
                    {label}
                </label>
                <label
                    className={classNames(color, styles[visualProps.quoteVariant])}>
                    {quoteReferenceNumber}
                </label>
            </div>
        ) : null;
    };

}

_ReferenceNumber.propTypes = {
    product: PropTypes.instanceOf(Immutable.Map),
    visualProps: PropTypes.object,
    contentProps: PropTypes.object
};

// default properties
_ReferenceNumber.defaultProps = {
    contentProps: {
        label: 'QUOTE REFERENCE NUMBER'
    },
    visualProps: {
        quoteVariant: 'default',
        labelVariant: 'default',
        textAlign: 'left'
    },
    product: Immutable.Map()
};
/**
 * Map the application state to our component's local props
 * @param {Object} state - the application's state / store
 * @returns {Object} - the props mapped from state
 */
const mapStateToProps = (state) => {
    return {
        product: selectedProductSelector(state)
    };
};

// map state to props through the connect function
const ReferenceNumber = connect(mapStateToProps)(_ReferenceNumber);

// export the component
export { _ReferenceNumber, ReferenceNumber };
